var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.26 17.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Help Text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "infoIcon1",
    d: "M8.5.15A8.5,8.5,0,1,0,17,8.65,8.51,8.51,0,0,0,8.5.15Zm0,16.29a7.79,7.79,0,1,1,7.79-7.79A7.79,7.79,0,0,1,8.5,16.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "infoIcon1",
    d: "M8.78,4.06a2.51,2.51,0,0,0-1.93.62A2.46,2.46,0,0,0,6,6.53h.71a1.77,1.77,0,0,1,2-1.76,1.76,1.76,0,0,1,1.56,1.55,1.79,1.79,0,0,1-.88,1.75,2.46,2.46,0,0,0-1.23,2.15v.56h.7v-.56a1.78,1.78,0,0,1,.88-1.54,2.48,2.48,0,0,0-1-4.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "infoIcon1",
    d: "M8.5,11.84a.71.71,0,1,0,.71.71A.71.71,0,0,0,8.5,11.84Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "infoIcon2",
    x: -527.5,
    y: -303.06,
    width: 1280,
    height: 1040
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.26f4e78dc055e8aef2612bfd414335ea.svg";
export { ForwardRef as ReactComponent };